<template>
    <nuxt-link
        class="button"
        :class="[blok.Style, { 'hidden-mobile': blok.HiddenMobile }]"
        :style="`
       ${blok.HoverColor.color ? `--hover-color: ${blok.HoverColor.color};` : ''};
       ${blok.HoverColorText.color ? `--hover-color-text: ${blok.HoverColorText.color};` : ''}
       ${blok.BackgroundColor.color ? `background-color: ${blok.BackgroundColor.color};` : ''}
       ${blok.FontSize ? `font-size: ${blok.FontSize}px;` : ''}
       ${blok.PaddingX ? `padding-left: ${blok.PaddingX}px;` : ''}
       ${blok.PaddingX ? `padding-right: ${blok.PaddingX}px;` : ''}
       ${blok.PaddingY ? `padding-top: ${blok.PaddingY}px;` : ''}
       ${blok.PaddingY ? `padding-bottom: ${blok.PaddingY}px;` : ''}
       border-width: ${blok.BorderWidth ? `${blok.BorderWidth}px` : '1px'};
       ${blok.BorderColor.color ? `border-color: ${blok.BorderColor.color};` : ''}
       ${blok.FontWeight ? `font-weight: ${blok.FontWeight};` : ''}
       ${blok.TextColor.color ? `color: ${blok.TextColor.color};` : ''}`"
        :to="url"
        external
    >
        <NuxtIcon v-if="customIcon" :name="customIcon" />
        <span>{{ blok.Text }}</span>
    </nuxt-link>
</template>

<script setup lang="ts">
import type { IL4Button } from '~/../types/components/L4Button';
import { getNormalizedIconifyIcon } from '@nuxt-monorepo/ui/utils/helpers';

const { blok } = defineProps<{ blok: IL4Button }>();
const url = blok.Link.email ? `mailto:${blok.Link.email}` : getL4InternalLink(blok.Link);

const customIcon = computed(() => {
    return getNormalizedIconifyIcon(blok.Icon, 'ri:arrow-right-s-line');
});
</script>

<style scoped lang="postcss">
.button {
    @apply flex min-w-[192px] leading-[17px] items-center justify-center self-center w-fit h-fit rounded-lg box-border border text-[white] bg-[#f98f43] cursor-pointer text-xl px-16 py-3 border-solid border-[#f98f43];
    transition:
        color 0.15s ease-in-out,
        background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;

    &:hover {
        @apply text-[color:var(--hover-color-text)] bg-[color:var(--hover-color)] !important;
    }

    .iconify {
        @apply mr-2.5;
        flex: 0 0 auto;
    }
}
</style>
